import { render } from "./Framework.vue?vue&type=template&id=3caaf2da&scoped=true"
import script from "./Framework.vue?vue&type=script&lang=js"
export * from "./Framework.vue?vue&type=script&lang=js"

import "./Framework.vue?vue&type=style&index=0&id=3caaf2da&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3caaf2da"]])

export default __exports__